import React from 'react';
import { MixpanelEventName } from 'utils/constants';
import { trackMixpanelEvent } from 'utils/utilMethods';

const useOnlineStatus = (
  onlineEventName: MixpanelEventName,
  offlineEventName: MixpanelEventName,
) => {
  const [isOffline, setIsOffline] = React.useState(!navigator.onLine);
  const [backOnline, setBackOnline] = React.useState(false);

  React.useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      setBackOnline((prev) => prev === false);
      trackMixpanelEvent(onlineEventName, {
        online: true,
      });
    };
    const handleOffline = () => {
      setIsOffline(true);
      trackMixpanelEvent(offlineEventName, {
        online: false,
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [offlineEventName, onlineEventName]);

  return [isOffline, backOnline];
};

export default useOnlineStatus;
